import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="pt-40 pb-24 container-x max-w-2xl mx-auto text-center" data-testid="payment-cancel-page">
      <div className="glass rounded-3xl p-12">
        <XCircle className="w-16 h-16 text-white/60 mx-auto mb-6" />
        <h1 className="font-display text-4xl">Payment <em className="not-italic">cancelled.</em></h1>
        <p className="mt-4 text-white/60">Your order is still in your cart. You can retry checkout anytime.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/cart" className="btn-gold">Return to Cart</Link>
          <Link to="/" className="btn-ghost-outline">Home</Link>
        </div>
      </div>
    </div>
  );
}
